import React, { useState } from "react";
import "./Roadmap.scss";

import RoadmapIcon1 from "../../assets/images/phase-1.png";
import RoadmapIcon2 from "../../assets/images/phase-2.png";
import RoadmapIcon3 from "../../assets/images/phase-3.png";
import RoadmapIcon4 from "../../assets/images/phase-4.png";

export default function Roadmap() {
	const [hoveredCard, setHoveredCard] = useState(null);

	const roadmapData = [
		{
			icon: RoadmapIcon1,
			phase: "Phase 1",
			title: "Lay the Foundation",
			description:
				"AurAI will enhance and reinforce AI models with advanced algorithms and extensive training for greater accuracy. Marketing & branding efforts will focus on strategic campaigns to increase visibility, attract users and establish AurAI as a leading name in crypto and AI.",
		},
		{
			icon: RoadmapIcon2,
			phase: "Phase 2",
			title: "Expanding Ecosystem",
			description:
				"AurAI will enhance and reinforce AI models with advanced algorithms and extensive training for greater accuracy. Marketing & branding efforts will focus on strategic campaigns to increase visibility, attract users and establish AurAI as a leading name in crypto and AI.",
		},
		{
			icon: RoadmapIcon3,
			phase: "Phase 3",
			title: "Scaling and Optimization",
			description:
				"AurAI will enhance and reinforce AI models with advanced algorithms and extensive training for greater accuracy. Marketing & branding efforts will focus on strategic campaigns to increase visibility, attract users and establish AurAI as a leading name in crypto and AI.",
		},
		{
			icon: RoadmapIcon4,
			phase: "Phase 4",
			title: "Deliver and Expand",
			description:
				"AurAI will enhance and reinforce AI models with advanced algorithms and extensive training for greater accuracy. Marketing & branding efforts will focus on strategic campaigns to increase visibility, attract users and establish AurAI as a leading name in crypto and AI.",
		},
	];

	return (
		<>
			<div className="roadmap">
				<div className="decoration roadmap-light-1"></div>

				<div className="roadmap-content-wrapper content-wrapper-lg">
					<h3 className="roadmap-small-title">
						Path To Achieving Goals
					</h3>
					<h2 className="roadmap-title">RoadMap</h2>
					<p className="roadmap-desc">
						Join us on our journey as we continue to innovate and
						expand our AI capabilities, with upcoming features and
						enhancements aimed at enriching your experience
					</p>

					<div className="roadmap-cards">
						{roadmapData.map((card, index) => (
							<div
								key={index}
								className={`roadmap-card-wrapper ${
									hoveredCard === index ? "open" : ""
								} ${
									hoveredCard !== null &&
									hoveredCard !== index
										? "collapse"
										: ""
								}`}
								onMouseEnter={() => setHoveredCard(index)}
								onMouseLeave={() => setHoveredCard(null)}
							>
								<div className="roadmap-card">
									<div className="gradient-bg"></div>
									<div className="gradient-bg-active"></div>
									<div className="noise-bg"></div>

									<div className="roadmap-card-content">
										<div className="roadmap-card-head">
											<img
												src={card.icon}
												alt="Roadmap Icon"
												className="roadmap-card-icon"
											/>

											<button className="learn-more-btn">
												Learn More
											</button>
										</div>

										<div className="roadmap-card-small-title">
											{card.phase}
										</div>

										<h4 className="roadmap-card-title">
											{card.title}
										</h4>

										<p className="roadmap-card-desc">
											{card.description}
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
}
